import type { Nullable, ProductEventDataList } from 'corgi-types';
import type { Sponsored } from 'graphql-ts-types';

import { ProductEvent } from '../../../enums/Tracking';
import { dispatchTrackingEventGA4 } from '../../../tracking/dispatchTrackingEventGA4';
import { getProductClickEventData } from '../../../tracking/productEventData';
import type { ArticleTracking } from '../../../types/Article';

interface GetLinkTrackingProps {
  href: string;
  tracking: ArticleTracking;
  list: ProductEventDataList;
  index: number;
  sponsored: Nullable<Sponsored>;
  hasMinPrice?: Nullable<boolean>;
}

export const getLinkTrackingProps = ({
  href,
  tracking,
  list,
  index,
  sponsored,
  hasMinPrice,
}: GetLinkTrackingProps) => ({
  href,
  onClick: () => {
    dispatchTrackingEventGA4({
      event: ProductEvent.Click,
      item_list_name: list,
      items: [
        getProductClickEventData({ position: index, tracking, list, sponsored, hasMinPrice }),
      ],
    });
  },
});

interface TrackImageCarouselNavigationProps {
  direction: 'next' | 'previous';
  list_index: number;
  image_index: number;
}

export const trackImageCarouselNavigation = ({
  direction,
  list_index,
  image_index,
}: TrackImageCarouselNavigationProps) => {
  dispatchTrackingEventGA4({
    event: ProductEvent.ViewClick,
    element: 'button',
    button_text: direction,
    image_index,
    list_index,
  });
};
